var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowReplaceItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5306 10.0306L11.5306 13.0306C11.3897 13.1715 11.1986 13.2507 10.9994 13.2507C10.8001 13.2507 10.609 13.1715 10.4681 13.0306C10.3272 12.8897 10.2481 12.6986 10.2481 12.4994C10.2481 12.3001 10.3272 12.109 10.4681 11.9681L12.1875 10.25H8C6.2104 10.248 4.49466 9.53622 3.22922 8.27078C1.96378 7.00534 1.25199 5.2896 1.25 3.5C1.25 3.30109 1.32902 3.11032 1.46967 2.96967C1.61032 2.82902 1.80109 2.75 2 2.75C2.19891 2.75 2.38968 2.82902 2.53033 2.96967C2.67098 3.11032 2.75 3.30109 2.75 3.5C2.75149 4.89193 3.30509 6.22642 4.28933 7.21067C5.27358 8.19491 6.60807 8.74851 8 8.75H12.1875L10.4675 7.03062C10.3266 6.88973 10.2474 6.69863 10.2474 6.49937C10.2474 6.30012 10.3266 6.10902 10.4675 5.96812C10.6084 5.82723 10.7995 5.74807 10.9987 5.74807C11.198 5.74807 11.3891 5.82723 11.53 5.96812L14.53 8.96813C14.6 9.03776 14.6555 9.12052 14.6934 9.21167C14.7313 9.30281 14.7508 9.40054 14.7509 9.49925C14.751 9.59796 14.7315 9.69571 14.6937 9.78689C14.6559 9.87808 14.6005 9.96091 14.5306 10.0306Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReplaceItem);
export default __webpack_public_path__ + "static/media/arrow-replace-item.7d5a5124.svg";
export { ForwardRef as ReactComponent };